import React, { SVGProps } from 'react'

export type CrosshairIconProps = SVGProps<SVGSVGElement>

const defaultArgs = {
    strokeWidth: 1.1,
    stroke: '#000000',
    fill: 'none',
    shapeRendering: 'crispEdges',
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0.5 0.5 28.5 28.5',
}

export const CrosshairsClosedIcon = ({ width = 28, height = 28, className, ...rest }: CrosshairIconProps) => {
    return (
        <svg
            {...defaultArgs}
            width={width}
            height={height}
            className={className}
            {...rest}
        >
            <path d="M 28,14 0,14 M 14,0 14,28" />
        </svg>
    )
}

export const CrosshairsFocusedIcon = ({ width = 28, height = 28, className, ...rest }: CrosshairIconProps) => {
    return (
        <svg
            {...defaultArgs}
            width={width}
            height={height}
            className={className}
            {...rest}
        >
            <path d="m 12,14 -12,0 M 28,14 l -12,0 m -2,2.021469 0,12 M 14,0 14,12" />
        </svg>
    )
}

export const CrosshairsOpenIcon = ({ width = 28, height = 28, className, ...rest }: CrosshairIconProps) => {
    return (
        <svg
            {...defaultArgs}
            width={width}
            height={height}
            className={className}
            {...rest}
        >
            <path d="M 10,14 H 0 M 28,14 H 18 m -4,4 V 28 M 14,0 V 10" />
        </svg>
    )
}
